<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-clip-rotate-multiple"></ngx-spinner>
<router-outlet></router-outlet>

<app-upload-in-blackground></app-upload-in-blackground>
<app-download-in-background></app-download-in-background>
